<template lang="pug">
div.map_features_container
  .city-select.fl(v-show="!drawMode")
    el-select(v-model="city" style="width: 100%;" :filter-method="filter" filterable)
      el-option(:value="null" label="全国")
      el-option(v-for="{ guid, districtValue } in cityList" :key="guid" :value="guid" :label="districtValue")
  MapSearch(v-show="!drawMode" @search="onSearch")
  div.top_right(v-if="!isImport" :style="{zIndex: drawMode ? '3001' : ''}")
    MapDropdown(v-show="!drawMode")
    MapSelect(
      v-show="!drawMode"
      :data="areaData" v-model="rangeValue"
      icon="iconfont icon-ditutoufang-toufangfanwei" placeholder="投放范围"
      customPlaceholder="自定义公里" customUnit="公里")
    el-button.map_button.act(
      v-show="drawMode" @click="reDraw"
      icon="iconfont icon-ditutoufang-huaquanxuanping"
    ) 重画
    el-button.map_button.act(
      v-show="drawMode" @click="closeDrawInMap"
      icon="iconfont icon-ditutoufang-huaquanxuanping"
    ) 退出画圈选屏
    el-button.map_button(
      v-show="!drawMode" @click="openDrawInMap"
      icon="iconfont icon-ditutoufang-huaquanxuanping"
    ) 画圈选屏
    //- el-button.map_button(icon="iconfont icon-ditutoufang-quanping") 全屏
  div.map_graphic_container
    span.g_title 推荐度
    div.g_content
      span.txt 低
      p.g_img
        span(v-for="i in [1,2,3,4,5]" :key="i" :class="['span', 'span'+i]")
      span.txt 高
  div.bottom_right
    span.map_btn.iconfont.icon-ditutoufang-fangda(@click="zoomIn")
    span.map_btn.iconfont.icon-ditutoufang-suoxiao(@click="zoomOut")

</template>

<script>
import { mapState } from 'vuex'
import '../components/mapComponents.scss'
import MapDropdown from '../components/MapDropdown'
import MapSelect from '../components/MapSelect'
import MapSearch from '../components/MapSearch'

export default {
  name: 'MapSearchFeatures',
  components: {
    MapDropdown,
    MapSelect,
    MapSearch
  },
  props: {
    value: {
      type: Number | String,
      default: 9
    }
  },
  data() {
    return {
      drawMode: false,
      areaData: [
        { value: 0, label: '不限' },
        { value: 1, label: '1公里内' },
        { value: 3, label: '3公里内' },
        { value: 5, label: '5公里内' },
        { value: 7, label: '7公里内' },
        { value: 9, label: '9公里内' }
      ],
      city: '',
      isInitCity: true,
      cityList: [
        // { value: 1, group: 'A', label: '阿克苏1' }
      ],
      isImport: false
    }
  },
  computed: {
    ...mapState({
      mapZoom: (state) => state.bmap.mapZoom,
      isOperateReset: state => state.bmap.isOperateReset,
      optSenior: (state) => state.bmap.mapSearchOptionsSenior,
      mapCitys: (state) => state.bmap.mapCityList
    }),
    rangeValue: {
      get() {
        return this.value
      },
      set(v) {
        if (v < 0 || v > 500) {
          return this.messageTip('投放范围须大于0并且小于500公里')
        }
        // 投放范围选择“不限”,将数据值置为空字符串
        if (v === 0) v = ''
        this.$store.commit('setOptionSenior', {
          ...this.optSenior,
          areaValue: v
        })
        this.$emit('input', v)
      }
    }
  },
  watch: {
    '$store.state.bmap.exportPointData': {
      deep: true,
      handler(data) {
        this.isImport = data.hasOwnProperty('successCount')
      }
    },
    mapCitys: {
      immediate: true,
      deep: true,
      handler(nv) {
        this.cityList = nv
      }
    },
    city(nv) {
      const params = {
        ...this.optSenior,
      }
      params.city = nv?nv: null
      this.$store.commit('setOptionSenior', {
        ...params
      })
      // 不是第一次初始化圆圈选择的城市,也不是重置操作时发送search事件
      if (!this.isInitCity && !this.isOperateReset) {
        this.$store.commit('setFocusPoint', '')
        this.$emit('search',false)
      }
    }
  },
  async created() {
    let res = await this.fetch('/boss/bp/v2/queryTownTree', { levelNum: 3 }, 'get')
    if (res && res.code == 0) {
      this.cityList = res.data || []
      this.$store.commit('setMapCityList', res.data || [])
      this.city = this.$store.state.bmap.mapZoomData.city.districtCode - 0
      this.$nextTick(() => {
        this.isInitCity = false
      })
    }
    this.$root.$on('operateResetSetCity', (data) => {
      this.city = data
    })
  },
  methods: {
    filter(str) {
      let trim = str.trim()
      if (!trim) this.cityList = this.mapCitys
      else this.cityList = this.mapCitys.filter((el) => el.districtValue.indexOf(trim) > -1)
    },
    onSearch() {
      this.$emit('search')
    },
    openDrawInMap() {
      this.drawMode = true
      this.$store.commit('setManualDraw', true)
    },
    closeDrawInMap() {
      this.drawMode = false
      this.$store.commit('setManualDraw', false)
    },
    reDraw() {
      this.$emit('reDraw')
    },
    zoomIn() {
      this.$store.commit('setMapZoom', this.mapZoom + 1)
      this.$emit('zoomChange')
    },
    zoomOut() {
      this.$store.commit('setMapZoom', this.mapZoom - 1)
      this.$emit('zoomChange')
    }
  }
}
</script>

<style lang="scss" scoped>
$graphic_color: #ff3973;

.city-select {
  border-radius: 4px;
  width: 100px;
  position: relative;
  background: #fff;
  pointer-events: all;

  ::v-deep .el-input {
    input {
      height: 36px;
      line-height: 36px;
      border: none;
    }

    .el-input__suffix {
      right: 5px;
    }

    .el-input__icon {
      line-height: 36px;
    }
  }
}

.map_features_container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px;
  pointer-events: none;
  z-index: 200; // 需≥160(高德.amap-logo,.amap-copyright的z-index为160)

  [class*='map'] {
    pointer-events: auto;
  }

  .top_right {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .bottom_right {
    position: absolute;
    right: 10px;
    bottom: 10px;

    .map_btn {
      display: block;
      width: 20px;
      height: 20px;
      margin-top: 5px;
      font-size: 18px;
      line-height: 20px;
      text-align: center;
      border-radius: 2px;
      background-color: #fff;
      cursor: pointer;

      &:active,
      &:hover {
        box-shadow: 1px 1px 2px #aaa inset;
      }

      // &:first-child{
      //     color: $graphic_color;
      //     margin-bottom: 10px;
      // }
    }
  }
}

.map_graphic_container {
  position: absolute;
  left: 4px;
  bottom: 1px;
  padding: 10px;
  width: 220px;
  user-select: none;
  background-color: rgba(#000, 0.9);
  border-radius: 4px;
  z-index: 0;

  .g_title {
    margin-right: 18px;
  }

  .txt {
    margin: 0 4px;
  }

  .g_title,
  .txt {
    color: #fff;
    font-size: 12px;
    line-height: 17px;
  }

  .g_content {
    display: inline-block;
  }

  .g_img {
    display: inline-block;
    padding: 3px;
    vertical-align: bottom;

    .span {
      float: left;
      width: 20px;
      height: 10px;
    }

    // @each $idx in 1,2,3,4,5 {
    //     .span#{$idx} {
    //         background-color: rgba($graphic_color, 0.2 * $idx);
    //     }
    // }
    .span1 {
      background: rgba(26, 25, 28, 0.7);
    }

    .span2 {
      background: rgba(74, 59, 76, 0.4);
    }

    .span3 {
      background: rgba(129, 72, 116, 0.6);
    }

    .span4 {
      background: rgba(187, 68, 123, 0.8);
    }

    .span5 {
      background: rgba(237, 81, 127, 1);
    }
  }
}

.map_button.act {
  color: rgba(255, 57, 115, 1);
}
</style>
